module.exports = __webpack_public_path__ + "static/media/TrueNorth_editvars.6af6d6bd.png";